export default __webpack_public_path__ + "0d88742798032b87b7169f7ffc2c2cd3.svg";